<app-chance-detail [chanceId]="data.chanceId"></app-chance-detail>
